import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type ContactMergedFromProps = {
  entry: UserAuditLogEntry<'CONTACT_MERGED_FROM'>;
};

/** Marker on the surviving contact's timeline: one or more contacts were merged in. */
export const ContactMergedFrom = ({
  entry,
}: ContactMergedFromProps): JSX.Element => {
  const names = entry.sources.map((source) => source.name ?? source.id);

  return (
    <UserActivityCard
      entry={entry}
      icon="combine"
      color={statusColors.info}
      title=""
      titleSuffix={
        <>
          <em>{names.length > 0 ? names.join(', ') : 'Contacts'}</em>
          {' merged in'}
        </>
      }
    />
  );
};
